export default __webpack_public_path__ + "static/media/tiktok-bg-mobile.0388ce20.png";